import { Container, Row, Col, Button } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const Section = () => (
  <S.Section>
    <Container>
      <Col size={{ giga: 10 }} offset={{ giga: 1 }}>
        <S.Title size="peta">
          <span>Comece a aproveitar</span> os benefícios que preparamos <br />
          especialmente para você!
        </S.Title>

        <Row justify="center">
          <Button as="a" href="/fidelidade/participar" size="mega">
            Começar agora
          </Button>
        </Row>
      </Col>
    </Container>
  </S.Section>
)

export default Section
